import { Component, Injector, Input, OnInit, signal } from '@angular/core';
import { BaseModalComponent } from '@card-software/library';
import { Role } from '../../../models/user-manager/roles';
import { FormControl, Validators } from '@angular/forms';
import { RolesProxyService } from '../../../proxies/roles.proxy.service';
import { MessageService } from 'primeng/api';
import { AccessType } from '../../../models/user-manager/access-type';
import { ACCESS_TYPE_LABELS, AccessTypeLabel } from '../../../models/user-manager/access-type-labels';

@Component({
  selector: 'app-user-set-roles',
  templateUrl: './user-set-roles.component.html',
  styleUrl: './user-set-roles.component.scss',
})
export class UserSetRolesComponent extends BaseModalComponent<Role | null> implements OnInit {
  @Input() role: Role | null = null;

  isUpdate = signal(false);

  name = new FormControl('', [Validators.required]);
  description = new FormControl('', [Validators.required]);
  /** Standard or Global (#6263): only groups of the same type can hold the role. */
  type = new FormControl<AccessType>(AccessType.Standard, { nonNullable: true });

  readonly typeOptions: AccessTypeLabel[] = ACCESS_TYPE_LABELS;

  constructor(
    injector: Injector,
    private roleProxyService: RolesProxyService,
    private messageService: MessageService,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.role) {
      this.isUpdate.set(true);
      this.setInitialData(this.role);
    }
  }

  private setInitialData(role: Role) {
    this.name.setValue(role.name ?? '');
    this.description.setValue(role.description ?? '');
    this.type.setValue(role.type ?? AccessType.Standard);
  }

  onClose() {
    this.close({ action: 'close', data: null });
  }

  onSubmit() {
    const role: Role = {
      id: this.role?.id ?? '',
      name: this.name.value ?? '',
      description: this.description.value ?? '',
      type: this.type.value,
    };

    if (this.isUpdate()) {
      this.roleProxyService.updateRole(role).subscribe({
        next: () => {
          this.close({ action: 'save', data: null });
          this.messageService.add({
            severity: 'secondary',
            summary: 'Success',
            detail: `Role '${role.name}' updated successfully`,
            key: 'main',
            life: 2500,
          });
        },
        error: (error) => {
          console.log('error', error);
        },
      });
      return;
    }

    this.roleProxyService.createRole(role).subscribe({
      next: (response) => {
        this.close({ action: 'save', data: null });
        this.messageService.add({
          severity: 'secondary',
          summary: 'Success',
          detail: `Role '${response.data?.name}' created successfully`,
          key: 'main',
          life: 2500,
        });
      },
      error: (error) => {
        console.log('error', error);
      },
    });
  }
}
